<script setup>
import { computed } from 'vue';
const props = defineProps({
  attributes: { type: Object, default: () => ({}) },
});
const message = computed(() => {
  const deletion =
    props.attributes.tgDeleteStatus || props.attributes.tg_delete_status;
  if (deletion === 'queued') return 'Удаляем в Telegram…';
  if (deletion === 'stale')
    return 'Не удалось обновить статус удаления. Обновите диалог.';
  if (deletion === 'unknown')
    return 'Удаление не подтверждено. Проверьте Telegram.';
  if (deletion === 'failed')
    return 'Не удалось удалить в Telegram. Проверьте доступ аккаунта.';
  const sending =
    props.attributes.tgDeliveryStatus || props.attributes.tg_delivery_status;
  if (sending === 'queued') return 'Отправляем в Telegram…';
  if (sending === 'unknown')
    return 'Доставка не подтверждена. Проверьте Telegram перед повторной отправкой.';
  if (sending === 'failed')
    return 'Не отправлено. Проверьте режим группы, права бота и файл.';
  return '';
});
</script>

<template>
  <p
    v-show="message"
    class="m-0 flex max-w-md items-start gap-1.5 text-xs text-n-slate-11"
    role="status"
  >
    <span class="i-lucide-info mt-0.5 size-3 shrink-0" aria-hidden="true" />
    {{ message }}
  </p>
</template>
